import request from "@/utils/request";
export default {
  // 聊天历史记录接口
  search({ keyword = "", tags = "", pageIndex = 1, pageSize = 20, searchType = "", userId = "", msgId = "", t = "", orderby = "" } = {}) {
    return request.post("/ChatHistory/Search", {
      keyword,
      tags,
      pageIndex,
      pageSize,
      searchType,
      userId,
      t,
      msgId,
      orderby
    });
  },
  // 用户自己的聊天历史记录接口
  myHistory({ keyword = "", tags = "", pageIndex = 1, pageSize = 20, searchType = "", userId = "", msgId = "", orderby = "" } = {}) {
    return request.post("/ChatHistory/My", {
      keyword,
      tags,
      pageIndex,
      pageSize,
      searchType,
      userId,
      msgId,
      orderby
    });
  },
  // 主题详情
  detail(id) {
    return request.post("/ChatTopic/GetDetail", { MsgId: id });
  },
  // 主题详情下的用户回复
  detailList({ id, pageIndex = 1, pageSize = 10, msgType }) {
    return request.post("/ChatTopic/GetDetailReplies", {
      PageSize: pageSize,
      PageIndex: pageIndex,
      MsgId: id,
      MsgType: msgType
    });
  },
  // 点赞
  like(id) {
    return request.post("/ChatMessage/SetLike", {
      MsgId: id
    });
  },
  // 已经点赞的列表
  likeList() {
    return request.post("/ChatMessage/GetLikes");
  },
  // 举报
  report({ msgId, category, detail }) {
    return request.post("/ChatMessage/Complaint", {
      MsgId: msgId,
      Category: category,
      Detail: detail
    });
  },
  // 设置未读消息
  unReadInfo() {
    return request.post("/ChatUser/GetUnReadInfo");
  },
  // 更新未读消息
  updateUnRead(id) {
    return request.post("/ChatUser/UpdateUnRead", {
      MsgId: id
    });
  },
  // 设为顶置
  setTop({ beans, id, days = 1 }) {
    return request.post("/ChatTopic/SetTop", {
      DailyBeans: beans,
      MsgId: id,
      Days: days
    });
  },
  // 获取顶置主题的详情
  getTopInfo(id) {
    return request.post("/ChatTopic/GetTopMessage", {
      MsgId: id
    });
  },
  // 获取广播消息
  getBroadcast() {
    return request.post("/Bidding/GetBroadcast");
  },
  // 获取上线的用户
  getOnline() {
    return request.post("/IMConnection/GetOnline");
  },
  // 设置广播
  setBroadcast({ msgId, beans, days }) {
    return request.post("/Bidding/JoinBroadcast", {
      MsgId: msgId,
      UnitBeans: beans,
      Days: days
    });
  },
  // 获取当前广播竞拍价格
  getBidding(id) {
    return request.post("/Bidding/GetBroadcastStatus", {
      MsgId: id
    });
  },
  // 搜索广告
  getAdvert() {
    return request.post("/Advert/ErpIMSearch");
  }
};
